import React from "react";
import { Button } from "../../Components/UI/atoms/Button";
import { faAngleRight, faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import { FooterWrapper } from "./styles";
import { color } from "../../theme";
import { Col, Row } from "antd";

const FooterButton = ({
  onBack,
  onNext,
  hideNext,
  hideBack,
  mobileNextPos = 'right',
  colorType = "secondary",
  backLabel = "Back",
  nextLabel = "Next",
  disableNext = false,
}) => (
  <FooterWrapper>
    <Row justify="space-between">
      {!hideBack && <Col span={12}>
        <Button
          label={backLabel}
          prefix={faAngleLeft}
          color={colorType === "secondary" ? color.primary11 : "white"}
          type={colorType}
          onClick={onBack}
        />
      </Col>}
      {!hideNext && <Col 
          span={hideBack ? 24 : 12}
          className="cls_col_footer_align"
          style={{ "--footer-align": mobileNextPos }}
         >
        <Button
          label={nextLabel}
          suffix={faAngleRight}
          onClick={onNext}
          disabled={disableNext}
        />
      </Col>}
    </Row>
  </FooterWrapper>
);
export default FooterButton;
